import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/erp/ui";
import { toast } from "sonner";
import { Users, PackageOpen } from "lucide-react";
import { TeamJobForm, NeedForm } from "@/components/erp/special/SpecialForms";
import { TeamJobs, NeedWos, SpecialSettings } from "@/components/erp/special/SpecialLists";

const Choice = ({ icon: I, title, desc, code, onClick, testid }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className="group text-left rounded-2xl border border-slate-200 bg-white p-5 hover:border-slate-900 hover:-translate-y-0.5 transition-[transform,border-color] duration-200">
    <div className="flex items-center gap-3"><span className="w-10 h-10 rounded-xl bg-slate-900 text-white grid place-items-center"><I className="w-5 h-5" /></span>
      <div><div className="font-semibold">{title}</div><div className="font-mono text-[11px] text-slate-400">kode {code}-…</div></div></div>
    <p className="text-xs text-slate-500 mt-3">{desc}</p>
  </button>
);

const TABS = [["team", "Tim khusus"], ["need", "Kebutuhan khusus"]];

export default function Projects() {
  const [customers, setCustomers] = useState([]);
  const [meta, setMeta] = useState(null); const [sp, setSp] = useState({ team_jobs: [], need_wos: [] });
  const [tab, setTab] = useState("team"); const [form, setForm] = useState(""); const [denied, setDenied] = useState(false);
  const load = () => {
    api.get("/special/list").then(({ data }) => setSp(data)).catch((e) => { if (e?.response?.status === 403) setDenied(true); else toast.error("Gagal memuat tugas khusus"); });
    api.get("/special/settings").then(({ data }) => setMeta(data)).catch(() => {});
  };
  useEffect(() => { load(); api.get("/customers").then(({ data }) => setCustomers(data)).catch(() => {}); }, []);
  const saved = () => { setForm(""); load(); };
  if (denied) return <div className="p-6 text-sm text-slate-500" data-testid="prj-denied">Anda tidak punya akses ke Projects.</div>;
  return (
    <div>
      <PageHeader title="Projects" subtitle="Pilih tindakan: pekerjaan tim khusus atau kebutuhan khusus mengeluarkan WO." />
      {meta?.can_create && <div className="grid md:grid-cols-2 gap-4 mb-6">
        <Choice testid="pick-team-job" icon={Users} code={meta.settings.code_team} title="Pekerjaan Tim KHUSUS" onClick={() => { setForm("team"); setTab("team"); }}
          desc="Menunjuk tim untuk kerjaan di luar kerjaan utama (event, exhibition, instalasi, field, survei). Uang transport, makan & dinas dihitung otomatis setelah disetujui." />
        <Choice testid="pick-need-wo" icon={PackageOpen} code={meta.settings.code_need} title="Kebutuhan Khusus · keluarkan WO" onClick={() => { setForm("need"); setTab("need"); }}
          desc="WO untuk sample, display toko, timelapse (biaya marketing) atau stock barang toko jualan (biaya modal). Tahapan sama persis seperti WO reguler." />
      </div>}
      {meta?.is_owner && <SpecialSettings key={JSON.stringify(meta.settings)} meta={meta} load={load} />}
      <div className="flex gap-2 mb-4 overflow-x-auto whitespace-nowrap pb-1">{TABS.map(([k, l]) => (
        <button key={k} type="button" data-testid={`prj-tab-${k}`} onClick={() => setTab(k)} className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${tab === k ? "bg-slate-900 text-white border-slate-900" : "border-slate-300"}`}>
          {l} ({k === "team" ? sp.team_jobs.length : sp.need_wos.length})</button>
      ))}</div>
      {tab === "team" && meta && <TeamJobs rows={sp.team_jobs} meta={meta} load={load} />}
      {tab === "need" && <NeedWos rows={sp.need_wos} />}
      {meta && form === "team" && <TeamJobForm open onClose={() => setForm("")} meta={meta} customers={customers} onSaved={saved} />}
      {meta && form === "need" && <NeedForm open onClose={() => setForm("")} meta={meta} customers={customers} onSaved={saved} />}
    </div>
  );
}
